import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/profil_icon.svg'
import _imports_1 from '@/assets/add_icon.svg'
import _imports_2 from '@/assets/book.svg'
import _imports_3 from '@/assets/stats.svg'
import _imports_4 from '@/assets/import.svg'
import _imports_5 from '@/assets/news.svg'
import _imports_6 from '@/assets/question.svg'
import _imports_7 from '@/assets/UNUCR_logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "hamburger" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hamburger-inner" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "nav-links" }
const _hoisted_4 = { class: "nav-element" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_0,
  alt: "Profil"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Mon profil UNUCR")
const _hoisted_7 = { class: "nav-element" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_1,
  alt: "Plus"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Saisir une fiche ")
const _hoisted_10 = { class: "nav-element" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_2,
  alt: "Livre"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Catégories")
const _hoisted_13 = { class: "nav-element" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_3,
  alt: "Statistiques"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Statistiques")
const _hoisted_16 = { class: "nav-element" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_4,
  alt: "Import"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Imports")
const _hoisted_19 = { class: "nav-element" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "nav-icon",
  src: _imports_4,
  alt: "Télécharger"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Télécharger")
const _hoisted_22 = { class: "nav-element" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  width: "30",
  class: "nav-icon",
  src: _imports_5,
  alt: "News"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Nouveautés")
const _hoisted_25 = { class: "nav-element" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  width: "30",
  class: "nav-icon",
  src: _imports_6,
  alt: "FAQ",
  style: {"filter":"brightness(100)"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Aide")
const _hoisted_28 = { class: "container" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "UNUCR-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "UNUCR")
], -1)

import { useUser } from "@/domains/auth/user";
import { ref } from "@vue/reactivity";
import { onMounted, onUnmounted } from "@vue/runtime-core";
import { useRouter } from "vue-router";
import { dispatch } from "../bus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const navToggled = ref(false);
const navRef = ref<HTMLElement | null>(null);

onMounted(() => {
    onNavStateChanged(true);
});

onUnmounted(() => {
    dispatch<string>("nav-toggle-update-width", "0");
});

function toggleNav() {
    navToggled.value = !navToggled.value;
    onNavStateChanged(navToggled.value);
}

function onNavStateChanged(isOpened: boolean) {
    if (!navRef.value) return;
    dispatch<string>(
        "nav-toggle-update-width",
        isOpened
            ? window.getComputedStyle(navRef.value).getPropertyValue("width")
            : "0"
    );
}

const { user, logout: userLogout } = useUser();
const router = useRouter();

router.afterEach(() => {
    navToggled.value = false;
});

function logout() {
    userLogout(router);
}

function onCreatingSheet() {
    if ("sheets.create" === router.currentRoute.value.name) {
        window.location = router.currentRoute.value
            .fullPath as unknown as Location;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-toggle", { 'is-active': navToggled.value }]),
      onClick: toggleNav
    }, _hoisted_2, 2),
    _createElementVNode("nav", {
      ref_key: "navRef",
      ref: navRef
    }, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'index' }
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'sheets.create' },
            onClick: onCreatingSheet
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'categories.index' }
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("li", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'statistics' }
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'import' }
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'download' }
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'news' }
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: { name: 'faqs.public' }
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        (_unref(user))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link",
              onClick: _cache[0] || (_cache[0] = () => logout())
            }, " Déconnexion "))
          : _createCommentVNode("", true)
      ])
    ], 512)
  ], 64))
}
}

})